import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ToastController,
  ModalController
} from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { _getStorage } from "src/app/utils/local-storage";
import { errMsg } from "../../../text_control/error-msg";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";
import isValidThaiID from 'thai-id-validator';
import { ManualModalComponent } from "../../../shared/components/manual-modal/manual-modal.component";

export interface Fruit {
  numbers: string;
}

@Component({
  selector: "app-customer-add",
  templateUrl: "./customer-add.component.html",
  styleUrls: ["./customer-add.component.scss"],
})
export class CustomerAddComponent implements OnInit {

  public text_addr: any = {};
  public text_btn: any = {};
  buyer_agree_tmp = "Y";
  buyer_branch_no = "";
  buyer_citizen_id = "";
  buyer_company_name = "";
  buyer_fname = "";
  buyer_main_branch_no;
  buyer_passpost_id = "";
  buyer_phone = "";
  buyer_sname = "";
  buyer_tax_id: any = "";
  branch_no = "";

  seller_id = null;
  building_no = "";
  building_name = "";
  house_no = "";
  village_no = "";
  room_no = "";
  floor = "";
  lane = "";
  road = "";
  sub_district = "";
  distric = "";
  province = "";
  postcode = "";
  phone: any = "";
  email = "";
  address_status = "1";
  buyer_type = "";
  selectedDevice = "";

  showbranch1 = false;
  showbranch2 = true;
  District: any = [];
  subDistrict: any = [];
  postcodes: any = [];

  showbtn1 = true;
  showbtn2 = false;
  buyer_tax_id1 = "";
  template_lang: any = "TH";

  zipcode: any;
  district: any = {};
  dataprovinces: any;
  datadistricts: any;
  datasubdistricts: any;

  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showTH = false;
  showEN = true;
  showradio = false;
  showadd = false;
  showperson1 = false;
  showperson2 = false;
  showperson3 = false;
  showperson4 = false;
  showperson = true;
  showfont = true;
  showname = false;
  showname1 = false;
  branch = true;

  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN = "";
  addrENOther = "";

  showOther = false;
  redioaddress = "1";

  emailEN = "";
  telEN = "";

  showsaveTH = true;
  showsaveEN = false;

  showcard = true;
  noshowcard = false;
  cardplaceholder = "";
  cardID = true;
  showtoggle = true;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = ""
  searchProvince = ""
  addressManual = false;

  showCompanyName = false;
  showTaxIDType = false;

  cardEvent = ""

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  // Thai ID Validation
  taxIdValidationResult: boolean | null = null;

  isAddress = false;
  addressline1 = "";

  constructor(
    public appservice: ApiserviceService,
    public apiservice: ApiserviceService,
    public http: HttpClient,
    public toastController: ToastController,
    public alertController: AlertController,
    public appService: AppService,
    public route: Router,
    public loadingController: LoadingController,
    public storage: Storage,
    public modalController: ModalController
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.text_addr = ADDRESS;
    this.text_btn = BTN;
    this.appService.cardEvent.subscribe((v) => {
      this.cardEvent = v
      this.settingCard(v);
    });
  }

  ngOnInit() {

    this.isFindAddress = false;
    this.groupAddress = this.appService.address_thai
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    }

  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return String(item.zipcode).indexOf(val) > -1 || item.province.indexOf(val) > -1 || item.amphoe.indexOf(val) > -1 || item.district.indexOf(val) > -1;
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district
    this.district = item.amphoe
    this.province = item.province
    this.postcode = item.zipcode
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province
    this.searchProvince = ""

  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.postcode = ""
    }
    if (name === "Province") {
      this.province = ""
    }
    if (name === "District") {
      this.district = ""
    }
    if (name === "SubDistrict") {
      this.sub_district = ""
    }
  }

  checkProvince(event) {
    let province = this.appService.address_thai.filter((item) => item.province === event.target.value)
    console.log('event', event);
    if (province.length > 0) {
      setTimeout(() => {
        document.getElementById('inputEmail').focus();
      }, 1000);
    }
  }

  settingCard(v) {
    if (v === "0") {
      this.showCompanyName = false;
      this.showTaxIDType = false;
      this.buyer_type = "";
      this.cardID = false;
      this.showcard = false;
      this.noshowcard = true;
      this.showperson1 = true;
      this.showperson3 = false;
      this.showperson2 = false;
      this.showfont = false;
      this.showname = true;
      this.buyer_tax_id1 = "";
      this.branch = false;
    }
    if (v === "1") {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.buyer_type = "0";
      this.showperson1 = true;
      this.showperson3 = false;
      this.showperson2 = false;
      this.showfont = false;
      this.showname = true;
      this.buyer_tax_id1 = "";
      this.noshowcard = false;
      this.showcard = true;
      this.province = "";
      this.district = "";
      this.sub_district = "";
      this.cardID = true;
      this.showtoggle = true;
      this.branch = false;
      setTimeout(() => {
        document.getElementById('inputcompanyname').focus();
        this.cardplaceholder = "จุดเริ่มต้นเครื่องอ่านบัตร";
      }, 1);
    }
  }

  checkaddressTH() {
    this.template_lang = "TH";
    this.showsaveTH = true;
    this.showsaveEN = false;
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.template_lang = "EN";
    this.showsaveTH = false;
    this.showsaveEN = true;
    this.showTH = true;
    this.showEN = false;
  }

  checkaddrENOther() {
    this.showOther = this.addrENCountry !== "Other" ? false : true;
  }

  focusInput() {
    this.addrENCountry = Object(this.addrENOther);
  }
  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }
    if (val === "") {
      this.reloadcountry();
    }
  }
  reloadcountry() {
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }
  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

  async refresh() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please refresh...",
    });
    await loading.present();
    window.location.reload();
  }


  checkbranch1() {
    this.showbranch2 = true;
    this.buyer_branch_no = "";
  }
  checkbranch2() {
    this.showbranch2 = false;
    this.buyer_main_branch_no = "";
  }

  checktype(e, n) {
    // Clear tax ID validation result and value when changing buyer type
    this.taxIdValidationResult = null;
    this.buyer_tax_id = "";
    
    if (n === 1) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.showperson1 = true;
      this.showperson2 = false;
      this.showperson3 = false;
      this.showperson4 = false;
      this.showfont = false;
      this.showname = true;
      this.branch = false;
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id1 = "";

      this.province = "";
      this.district = "";
      this.sub_district = "";
      this.cardID = true;
      this.showtoggle = true;

      if(this.cardEvent === "0"){
        this.noshowcard = true;
        this.showcard = false;
        this.cardplaceholder = ""
      }else{
        this.noshowcard = false;
        this.showcard = true;
       
        setTimeout(() => {
          // this.ionViewDidEnter();
          document.getElementById('inputcompanyname').focus();
          this.cardplaceholder = "จุดเริ่มต้นเครื่องอ่านบัตร";
        }, 100);
      }

    }
    if (n === 2) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.showperson1 = false;
      this.showperson2 = true;
      this.showperson3 = false;
      this.showperson4 = false;
      this.showname1 = true;
      this.showfont = false;
      this.showname = false;
      this.branch = true;
      this.buyer_branch_no = "";
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id1 = "";
      this.cardID = false;
      this.showcard = false;
      this.noshowcard = true;
      this.showtoggle = false;
      this.buyer_tax_id1 = "";
      this.cardplaceholder = "";
    }
    if (n === 3) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.showperson1 = false;
      this.showperson2 = false;
      this.showperson3 = true;
      this.showperson4 = false;
      this.showfont = false;
      this.showname = true;
      this.branch = false;
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id = "";
      this.showcard = false;
      this.noshowcard = true;
      this.showtoggle = false;
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id1 = this.buyer_tax_id;
      this.cardplaceholder = "";
    }
    if (n === 4) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.showperson1 = false;
      this.showperson2 = false;
      this.showperson3 = false;
      this.showperson4 = true;
      this.showfont = false;
      this.showname = true;
      this.branch = false;
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id = "";
      this.showcard = false;
      this.noshowcard = true;
      this.showtoggle = false;
      this.buyer_main_branch_no = "00000";
      this.buyer_tax_id1 = this.buyer_tax_id;
      this.cardplaceholder = "";
    }
  }


  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkinput1(e) {
    this.buyer_tax_id = e.target.value.match(/[0-9]*/)[0];
  }
  checkTaxID1(e) {
    this.buyer_tax_id1 = e.target.value.match(/[0-9a-zA-Z]*/)[0];
  }
  creditcard_num: any;
  checkbranch(e, n) {
    console.log("[----event---]", e.target.value);
    this.buyer_branch_no = e.target.value.match(/[0-9]*/)[0];
  }
  checkpostcode(e) {
    this.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  dataTH: any;
  dataEN: any;
  datasave: any = [];
  async confirmBuyer(addr_type: string) {

    let phones = [];
    for (let i of this.fruits) {
      phones.push(i.numbers);
    }

    let addr = {
      sub_district:
        this.showcard === true
          ? this.checkUndefined(this.sub_district)
          : this.checkUndefined(this.sub_district),
      province:
        this.showcard === true
          ? this.checkUndefined(this.province)
          : this.checkUndefined(this.province),
      district:
        this.showcard === true
          ? this.checkUndefined(this.district)
          : this.checkUndefined(this.district),
      phones: phones,
    };

    let validate: string = this.validateRequest(addr_type, addr);
    if (validate != "") {
      return await this.ErrorMsg(validate);
    }

    let reqBody = this.getRequestBodyData(addr_type, addr);
    console.log("[confirmBuyer] reqBody : ", reqBody);

    let url = this.apiservice.apiUrl + this.apiservice.updateCustomer;

    try {
      this.appservice._post(url, reqBody).then(async (res: any) => {
        console.log("[============== res newCustomerData ===============]", res);
        this.datasave = res.data;
        if (res.statusCode === 200) {
          for (let i = 0; i < this.datasave.length; i++) {
            if (this.datasave[i].buyer_branch_no != "") {
              this.buyer_main_branch_no = "11111";
            }
          }
          if (this.datasave) {
          }
          const alert = await this.alertController.create({
            cssClass: "my-custom-class",
            message: "บันทึกข้อมูลเรียบร้อย",
            buttons: [
              {
                text: "OK",
                cssClass: "alertButton",
                handler: (blah) => {
                  this.showbtn2 = true;
                  this.showbtn1 = false;
                  this.showEN = true;
                  this.showTH = true;
                  this.showradio = true;
                  this.showadd = true;
                  this.showbranch2 = true;
                  this.showsaveEN = false;
                  this.showsaveTH = false;
                },
              },
            ],
          });
          await alert.present();
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
    } catch (error) {
      // this.ErrorMsg(errMsg.error);
    }
  }
  checkUndefined(data: string) {
    if (!data || data === undefined) return "";
    return data;
  }

  validateRequest(addr_type: string, addr: any): string {
    //buyer information
    if (this.buyer_type == "") return errMsg.buyer_type;
    if (this.buyer_company_name == "") return errMsg.buyer_company_name;
    if (this.buyer_type !== "2" && this.buyer_type !== "3" && this.buyer_tax_id == "")
      return errMsg.buyer_tax_id;
    if (
      this.buyer_type !== "2" && this.buyer_type !== "3" &&
      !this.appService.checkIdentityCardNumber(this.buyer_tax_id)
    )
      return errMsg.card_tax;
    if (this.buyer_type == "2" && this.buyer_tax_id1.trim() == "")
      return errMsg.buyer_tax_id;
    if (this.buyer_main_branch_no === "11111" && this.buyer_branch_no === "")
      return errMsg.buyer_main_branch_no;

      if (this.buyer_type == "2" && this.buyer_tax_id1.trim() == "")
      return errMsg.buyer_tax_id1;
    if (this.buyer_main_branch_no === "11111" && this.buyer_branch_no === "")
      return errMsg.buyer_main_branch_no;

    if (this.isAddress === true && this.addressline1 === "")
      return errMsg.errorAddressline1;

    if (this.isAddress === true && this.postcode === "") {
      return errMsg.notpostcode;
    }
    if (this.isAddress === true && this.postcode.length < 5 ) {
      return errMsg.notpostcode;
    }
    let email = "";

    // address
    if(this.isAddress === false){

    if (addr_type === "1") {
      let filterPostcode = this.groupAddress.filter((f) => f.zipcode === Number(this.postcode))
      let filterProvince = this.groupAddress.filter((f) => f.province === this.province)
      if (this.house_no == "") return errMsg.house_no;
      if (this.postcode == "") return errMsg.postcode;
      if (this.postcode !== "" && filterPostcode.length === 0) {
        return errMsg.notpostcode
      }
      if (addr.sub_district == undefined || addr.sub_district == "")
        return errMsg.sub_district;
      if (addr.district == undefined || addr.district == "")
        return errMsg.district;
      if (addr.province == undefined || addr.province == "")
        return errMsg.province;
      if (addr.province !== "" && filterProvince.length === 0) {
        return errMsg.notprovince;
      }
      email = this.email;
    } else {
      if (this.addrENProvince == "") return errMsg.addrENProvince;
      if (this.addrENPostCode == "") return errMsg.addrENPostCode;
      if (this.addrENCountry == "") return errMsg.addrENCountry;
      email = this.emailEN;
    }
  }


    if (email != "") {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(email)) return "รูปแบบ email ไม่ถูกต้อง";
    }
    return "";
  }

  getRequestBodyData(addr_type: string, addr_detail: any) {
    let result = {
      newCustomerData: {
        buyer_type: this.buyer_type,
        buyer_company_name: this.buyer_company_name,
        buyer_people_id: "",
        buyer_main_branch_no:
          this.buyer_branch_no !== "" ? "" : this.buyer_main_branch_no,
        buyer_branch_no:
          this.buyer_branch_no === ""
            ? ""
            : this.buyer_branch_no.padStart(5, "0"),
        buyer_citizen_id: this.buyer_citizen_id,
        buyer_tax_id: this.buyer_type === "2" ? this.buyer_tax_id1 : this.buyer_tax_id,
        buyer_passpost_id: this.buyer_passpost_id,
        buyer_agree_tmp: this.buyer_agree_tmp, // ===>>> key tmp [ ยินยอม Y / ไม่ยินยอม N]
        user_id: this.userID,
        template_lang: this.template_lang,
        buyer_status: "active",
        address_detail: {
          type_addr: addr_type,
          building_no: this.building_no,
          building_name: this.building_name,
          house_no: this.house_no,
          village_no: this.village_no,
          room_no: this.room_no,
          floor: this.floor,
          lane: this.lane,
          road: this.road,
          sub_district: addr_detail.sub_district,
          district: addr_detail.district,
          province: addr_detail.province,
          postcode: String(this.postcode),
          phone: addr_detail.phones.join(","),
          fax: "",
          email: addr_type == "1" ? this.email : this.emailEN,
          address_status: "active",
          addr_agree_tmp: this.buyer_agree_tmp,
          inter_province: this.addrENProvince,
          inter_postcode: this.addrENPostCode,
          inter_country: this.addrENCountry,
          inter_tel: this.telEN,
          inter_address_line1: this.addrEN,
          inter_fax: "",
          seller_id: "",
          buyer_id: "",
          user_id: this.userID,
          is_addresstxt: this.isAddress,
          addressline1: this.addressline1 || "",
        },
      },
    };

    return result;
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[] = [];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.fruits.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  goBack() {
    this.appService.setActive(1);
    this.route.navigate(["/customer-search"]);
  }
  checkemail(e) {
    this.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  ionViewDidEnter() {
    const v = _getStorage(STORAGE.DATA_CARDID)
      this.cardEvent = v
      this.settingCard(v);

    var showprovince = document.getElementById("showSelectProvince");
    var notshowprovince = document.getElementById("notshowselectProvince");

    if (showprovince !== null) {
      showprovince.style.display = "none";
      notshowprovince.style.display = "none";
    }

    this.reloadcountry();
    this.appService.setActive(2);
    this.buyer_agree_tmp = "Y";
    this.buyer_branch_no = "";
    this.buyer_citizen_id = "";
    this.buyer_company_name = "";
    this.buyer_fname = "";
    this.buyer_main_branch_no;
    this.buyer_passpost_id = "";
    this.buyer_phone = "";
    this.buyer_sname = "";
    this.buyer_tax_id = "";
    this.branch_no = "";
    this.room_no = "";
    this.floor = "";
    this.seller_id = null;
    this.building_no = "";
    this.building_name = "";
    this.house_no = "";
    this.village_no = "";
    this.lane = "";
    this.road = "";
    this.sub_district = "";
    this.distric = "";
    this.province = "";
    this.postcode = "";
    this.phone = "";
    this.email = "";
    this.address_status = "1";
    this.selectedDevice = "";

    this.showbranch1 = false;
    this.showbranch2 = true;

    this.showbtn1 = true;
    this.showbtn2 = false;
    this.buyer_tax_id1 = "";
    this.template_lang = "TH";

    this.zipcode = "";
    this.postcodes = "";
    this.district = "";
    this.country = "";

    this.showTH = false;
    this.showEN = true;
    this.showradio = false;
    this.showadd = false;

    this.addrENCountry = "";
    this.addrENPostCode = "";
    this.addrENProvince = "";
    this.addrEN = "";
    this.addrENOther = "";

    this.showOther = false;
    this.redioaddress = "1";

    this.emailEN = "";
    this.telEN = "";

    this.visible = true;
    this.selectable = true;
    this.removable = true;
    this.addOnBlur = true;
    this.fruits = [];
  }

  // Thai ID Validation Method
  validateThaiID(type?: string, elementId?: string) {
    
    // Reset validation result
    this.taxIdValidationResult = null;
    
    // Check if buyer_tax_id has value and is 13 characters
    if (!this.buyer_tax_id) {
      this.showValidationAlert('กรุณากรอกเลขประจำตัวผู้เสียภาษี');
      return false;
    }

    if (this.buyer_tax_id.length !== 13) {
      this.showValidationAlert('เลขประจำตัวผู้เสียภาษีต้องมี 13 หลัก');
      return false;
    }
    if (type == '0' && this.buyer_tax_id.startsWith('0')) {
      this.showValidationAlert('รูปแบบเลขประจำตัวผู้เสียภาษีเป็นประเภทนิติบุคคล');
      return false;
    }
    if (type == '1' && !this.buyer_tax_id.startsWith('0')) {
      this.showValidationAlert('รูปแบบเลขประจำตัวผู้เสียภาษีเป็นประเภทบุคคลธรรมดา');
      return false;
    }

    // Validate using thai-id-validator
    const isValid = isValidThaiID(this.buyer_tax_id);
    this.taxIdValidationResult = isValid;

  
    // Show result message
    if (isValid) {
      const message = type ? `✅ เลขประจำตัวผู้เสียภาษีถูกต้อง` : '✅ เลขประจำตัวผู้เสียภาษีถูกต้อง';
      this.showValidationToast(message, 'success');
    } else {
      const message = type ? `❌ เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง` : '❌ เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง';
      this.showValidationToast(message, 'danger');
    }
    return isValid
  }

  async showValidationAlert(message: string) {
    const alert = await this.alertController.create({
      header: 'การตรวจสอบเลขประจำตัวผู้เสียภาษี',
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }

  async showValidationToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'top',
      color: color
    });
    await toast.present();
  }

  // Clear validation result when tax ID changes
  onTaxIdChange() {
    this.taxIdValidationResult = null;
  }

  // Open manual modal
  async openManualModal() {
    const modal = await this.modalController.create({
      component: ManualModalComponent,
      componentProps: {
        manualType: 'customer',
        title: 'คู่มือการเพิ่มข้อมูลลูกค้า'
      },
      cssClass: 'manual-modal-large'
    });
    return await modal.present();
  }
}
